<form [formGroup]="formGroup" [ngClass]="classPrefix" *ngIf="formGroup" (ngSubmit)="handleSubmit()">
	@if (((country && !country.disabled) || hasCountryRestrictionFeature) && address.type !==
	addressType.LOCALIZED) {
	<ng-container *ngIf="!freeform?.includes('country'); else freeformCountry">
		<cm-autocomplete
			[options$]="countries$"
			formControlName="country"
			class="cm-form__field-group--full-width"
			[required]="address.type === addressType.MAILING">
			<cm-localize [name]="locs.AddressFormLabelCountry"></cm-localize>
			<div autocomplete-errors *ngIf="country.invalid && (country.dirty || country.touched)">
				<div *ngIf="country.errors.required">
					<cm-localize [name]="locs.AddressFormErrorCountryRequired"></cm-localize>
				</div>
				<div *ngIf="country.errors.noMatch">
					<cm-localize [name]="locs.AddressFormErrorInvalidCountry"></cm-localize>
				</div>
			</div>
			<div autocomplete-hints-end *ngIf="hasCountryRestrictionFeature">
				<cm-localize [name]="locs.AddressFormHintCountry"></cm-localize>
			</div>
		</cm-autocomplete>
	</ng-container>

	<ng-template #freeformCountry>
		<mat-form-field *ngIf="country" [ngClass]="classPrefix + '__field-group--full-width'">
			<mat-label>
				<cm-localize [name]="locs.AddressFormLabelCountry"></cm-localize>
			</mat-label>
			<input
				matInput
				name="country"
				formControlName="country"
				[required]="address.type === addressType.MAILING" />
			<mat-error *ngIf="country.invalid && (country.dirty || country.touched)">
				<div *ngIf="country.errors.required">
					<cm-localize [name]="locs.AddressFormErrorCountryRequired"></cm-localize>
				</div>
			</mat-error>
		</mat-form-field>
	</ng-template>
	}

	<mat-form-field *ngIf="line1 as model" [ngClass]="classPrefix + '__field-group--full-width'">
		<mat-label>
			<cm-localize [name]="locs.AddressFormLabelAddress"></cm-localize>
		</mat-label>
		<input matInput maxlength="256" name="line1" [formControl]="model" [required]="line1Req" />
		<mat-hint>
			<cm-localize [name]="locs.AddressFormHintAddress"></cm-localize>
		</mat-hint>
		<mat-hint align="end">{{ model?.value?.length || 0 }}/256</mat-hint>
		<mat-error *ngIf="model.invalid && (model.dirty || model.touched)">
			<div *ngIf="model.errors.required">
				<cm-localize [name]="locs.AddressFormErrorAddressRequired"></cm-localize>
			</div>
		</mat-error>
	</mat-form-field>

	<mat-form-field *ngIf="line2 as model" [ngClass]="classPrefix + '__field-group--full-width'">
		<mat-label>
			<cm-localize [name]="locs.AddressFormLabelAddressContinued2"></cm-localize>
		</mat-label>
		<input matInput maxlength="256" name="line2" [formControl]="model" />
		<mat-hint align="end">{{ model?.value?.length || 0 }}/256</mat-hint>
	</mat-form-field>

	<mat-form-field *ngIf="line3 as model" [ngClass]="classPrefix + '__field-group--full-width'">
		<mat-label>
			<cm-localize [name]="locs.AddressFormLabelAddressContinued3"></cm-localize>
		</mat-label>
		<input matInput maxlength="256" name="line3" [formControl]="model" />
		<mat-hint align="end">{{ model?.value?.length || 0 }}/256</mat-hint>
	</mat-form-field>

	<mat-form-field *ngIf="city as model">
		<mat-label>
			<cm-localize [name]="locs.AddressFormLabelCity"></cm-localize>
		</mat-label>
		<input matInput name="city" maxlength="256" [formControl]="model" [required]="cityReq" />
		<mat-hint align="end">{{ model?.value?.length || 0 }}/256</mat-hint>
		<mat-error *ngIf="model.invalid && (model.dirty || model.touched)">
			<div *ngIf="model.errors.required">
				<cm-localize [name]="locs.AddressFormErrorCityRequired"></cm-localize>
			</div>
		</mat-error>
	</mat-form-field>

	<cm-autocomplete
		[options$]="states$"
		formControlName="state"
		maxlength="256"
		[matchRequired]="(freeform && !freeform.includes('state')) || (states$ | async)?.length > 0"
		[required]="stateRequired">
		<cm-localize [name]="locs.AddressFormLabelState"></cm-localize>

		<span autocomplete-hints-end>{{ displayedStateCharacters$ | async }}/256</span>
		<div autocomplete-errors *ngIf="state.invalid && (state.dirty || state.touched)">
			<div *ngIf="state.errors.required">
				@if(hasVueValidation) {<cm-localize
					[name]="locs.AddressFormErrorStateRequiredVueHint"></cm-localize
				>}@else{<cm-localize [name]="locs.AddressFormErrorStateRequired"></cm-localize>}
			</div>
			<div *ngIf="state.errors.noMatch">
				<cm-localize [name]="locs.AddressFormErrorStateInvalid"></cm-localize>
			</div>
		</div>
	</cm-autocomplete>

	<mat-form-field *ngIf="postal as model">
		<mat-label>
			<cm-localize [name]="locs.AddressFormLabelPostal"></cm-localize>
		</mat-label>
		<input
			matInput
			[maxlength]="postalCodeMaxLength"
			name="postal"
			[formControl]="model"
			[required]="hasVueValidation" />
		<mat-hint align="end">{{ model?.value?.length || 0 }}/{{ postalCodeMaxLength }}</mat-hint>
		<mat-error *ngIf="model.invalid && (model.dirty || model.touched)">
			<div *ngIf="model.errors?.required">
				<cm-localize [name]="locs.AddressFormErrorPostalRequired"></cm-localize>
			</div>
			<div *ngIf="model.errors?.vueUsaPostalCode">
				<cm-localize [name]="locs.AddressFormErrorPostalVueUSA"></cm-localize>
			</div>
			<div *ngIf="model.errors?.vueCanadaPostalCode">
				<cm-localize [name]="locs.AddressFormErrorPostalVueCanada"></cm-localize>
			</div>
			<div *ngIf="model.errors?.maxlength">
				<cm-localize [name]="locs.AddressFormErrorPostalMaxLength"></cm-localize>
				{{ postalCodeMaxLength }}
			</div>
		</mat-error>
	</mat-form-field>

	<mat-form-field *ngIf="phone as model">
		<mat-label>
			<cm-localize [name]="locs.AddressFormLabelPhone"></cm-localize>
		</mat-label>
		<input
			matInput
			maxlength="90"
			name="phone"
			[formControl]="model"
			[required]="hasVueValidation" />
		<mat-hint align="end">{{ model?.value?.length || 0 }}/90</mat-hint>

		<mat-error *ngIf="model.invalid && (model.dirty || model.touched)">
			<div *ngIf="model.errors?.required">
				<cm-localize [name]="locs.AddressFormErrorPhoneRequired"></cm-localize>
			</div>
			<div *ngIf="model.errors?.vueUsaCanadaPhoneFormat">
				<cm-localize [name]="locs.AddressFormErrorPhoneVueUsaCanada"></cm-localize>
			</div>
			<div *ngIf="model.errors?.vueZerosPhoneFormat">
				<cm-localize [name]="locs.AddressFormErrorPhoneVueNoZeros"></cm-localize>
			</div>
		</mat-error>
	</mat-form-field>

	<mat-form-field *ngIf="fax as model">
		<mat-label>
			<cm-localize [name]="locs.AddressFormLabelFax"></cm-localize>
		</mat-label>
		<input matInput maxlength="90" name="fax" [formControl]="model" />
		<mat-hint align="end">{{ model?.value?.length || 0 }}/90</mat-hint>
	</mat-form-field>

	<div
		[ngClass]="classPrefix + '__field-group cp-form__field-group--checkbox'"
		*ngIf="business as model">
		<mat-checkbox [formControl]="model">
			<cm-localize [name]="locs.AddressFormLabelBusinessAddress"></cm-localize>
		</mat-checkbox>
	</div>

	<div [ngClass]="classPrefix + '__actions'">
		<button mat-raised-button type="submit" color="primary">
			<ats-icon name="circle-check"></ats-icon>
			<cm-localize [name]="locs.AddressFormButtonUpdateAddress"></cm-localize>
		</button>

		<button
			*ngIf="!hideCancel"
			mat-raised-button
			type="button"
			color="warn"
			(click)="cancel.emit()">
			<ats-icon name="circle-close"></ats-icon>
			<cm-localize [name]="locs.AddressFormButtonCancel"></cm-localize>
		</button>
	</div>
</form>
